//@flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { HighlightBox } from '../../../../atoms';

import { TicketAmount } from './ticket-amount';
import { TicketDue } from './ticket-due';
import { TicketCode } from './ticket-code';

export function Ticket(): Node {
  return (
    <Grid>
      <GridSlot name="amount">
        <TicketAmount />
      </GridSlot>
      <GridSlot name="due">
        <TicketDue />
      </GridSlot>
      <GridSlot name="code">
        <TicketCode />
      </GridSlot>
    </Grid>
  );
}

const GridSlot = styled(HighlightBox)`
  grid-area: ${props => props.name};
`;

const Grid = styled.div`
  display: grid;
  grid-template-areas: "amount due"
                       "code code";
  ${GridSlot} {
    border-style: none;
    border-radius: 0;
    &:nth-child(1) {
      border-top-left-radius: 5px;
      border-style: solid none none solid;
    }
    &:nth-child(2) {
      border-top-right-radius: 5px;
      border-style: solid solid none solid;
    }
    &:nth-child(3) {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      border-style: solid;
    }
  }
`;
